import { makeCrud } from "./crud";

const crud = makeCrud("customers");

export const fetchCustomers  = (filters, signal) => crud.list(filters, signal);
export const fetchCustomer   = crud.get;
export const createCustomer  = crud.create;
export const updateCustomer  = crud.update;
export const deleteCustomer  = crud.remove;
